declare global {
	interface Window {
		CustomEvent: typeof CustomEvent
	}
}

export const createCustomEvent = <T>(
	typeArg: string,
	eventInitDict?: CustomEventInit<T> | undefined,
): CustomEvent<T> => {
	if (typeof window.CustomEvent === 'function') {
		return new window.CustomEvent<T>(typeArg, eventInitDict)
	}

	return new (CustomEvent as any)(typeArg, eventInitDict)
}

// 不要用 class extends Event ，因为在 IE10 下面 Event 不是一个构造函数
function CustomEvent<T>(
	typeArg: string,
	customEventInit: CustomEventInit<T> = {},
) {
	const evt = document.createEvent('CustomEvent')
	evt.initCustomEvent(typeArg, false, false, customEventInit.detail)
	return evt
}
CustomEvent.prototype = Event.prototype
